var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
		_vm.$style['app-button'],
		{
			[_vm.$style['app-button--white']]: _vm.white,
			[_vm.$style['app-button--danger']]: _vm.danger,
			[_vm.$style['app-button--warning']]: _vm.warning,
			[_vm.$style['app-button--success']]: _vm.success,
			[_vm.$style['app-button--icon']]: _vm.icon,
			[_vm.$style['app-button--full']]: _vm.full,
			[_vm.$style['app-button--loading']]: _vm.loading
		}
	],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('BaseRipple'),_c('span',{class:_vm.$style['app-button__content']},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }